exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\nem {\n  color: #f56c6c;\n}\n", ""]);

// exports
